import promotion from './promotionConfig';
import apiClient from 'whitelabel_api_requests';

export default () => {
    return apiClient(promotion.apiClientConfig);
};
